import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Mihail_data } from '../../assets'

const MihailLucianBirsa = () => {
  return (
    <>
    <PanelMemberTemplate {...Mihail_data}/>
    </>
  )
}

export default MihailLucianBirsa
